(() => {
  console.log('[Bundle Qty] script loaded');

  function getBundleStep(button) {
    const item = button.closest('.atlas-upsell-cart-item');
    if (!item) return 1;

    const img = item.querySelector('img[alt]');
    if (!img) return 1;

    const alt = img.getAttribute('alt') || '';

    /*
      Kaching/Atlas alt examples:
      "Momentum Day + Evening System – 2 Day + 2 Evening"
      "Product Name – 3 Pack"
      "Product Name - 2 Month Supply"

      We only inspect the text AFTER the final separator,
      so numbers in the product name do not interfere.
    */

    const parts = alt.split(/\s+[–—-]\s+/);

    if (parts.length < 2) return 1;

    const bundleLabel = parts[parts.length - 1].trim();

    // Bundle label must START with a quantity
    const match = bundleLabel.match(/^(\d+)\b/);

    if (!match) return 1;

    const step = parseInt(match[1], 10);

    // Safety limit
    if (!Number.isFinite(step) || step < 1 || step > 20) {
      return 1;
    }

    return step;
  }

  document.addEventListener(
    'click',
    function (event) {
      const target =
        event.target instanceof Element
          ? event.target
          : event.target?.parentElement;

      if (!target) return;

      const button = target.closest(
        '.atlas-upsell-cart-item-quantity-up, .atlas-upsell-cart-item-quantity-down'
      );

      if (!button) return;

      const step = getBundleStep(button);

      // Quantity-1 bundles and normal products use Atlas normally
      if (step === 1) return;

      const current = parseInt(
        button.getAttribute('data-current-quantity'),
        10
      );

      if (!Number.isFinite(current)) return;

      const isUp = button.classList.contains(
        'atlas-upsell-cart-item-quantity-up'
      );

      let atlasCurrent;

      if (isUp) {
        /*
          Atlas adds 1 itself.

          step 2:
          2 → pretend 3 → Atlas makes 4

          step 3:
          3 → pretend 5 → Atlas makes 6
        */
        atlasCurrent = current + step - 1;
      } else {
        /*
          Atlas subtracts 1 itself.

          4 with step 2:
          pretend 3 → Atlas makes 2

          6 with step 3:
          pretend 4 → Atlas makes 3
        */
        atlasCurrent = Math.max(
          1,
          current - step + 1
        );
      }

      button.setAttribute(
        'data-current-quantity',
        String(atlasCurrent)
      );

      console.log('[Bundle Qty]', {
        bundleStep: step,
        actualCurrentQty: current,
        valuePassedToAtlas: atlasCurrent,
        direction: isUp ? 'up' : 'down'
      });
    },
    true
  );
})();